<template>
  <div class="contact-hero-section">
    <div class="hero-content">
      <div class="hero-text">
        <h1 class="hero-title">
          <span class="subtitle">Get help anytime with our</span>
          <span class="golden-text">24/5 Customer Support Service</span>
        </h1>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContactHero'
}
</script>

<style scoped>
.contact-hero-section {
  min-height: 507px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.contact-hero-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: transparent;
  background-image: linear-gradient(185deg, var(--e-global-color-blocksy_palette_2) 0%, var(--e-global-color-primary) 100%);
  z-index: 1;
}

.contact-hero-section::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('/wp-content/uploads/2024/02/cust-service-3.jpg');
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  opacity: 0.6;
  z-index: 2;
}

.hero-content {
  max-width: 1200px;
  width: 100%;
  padding: 0 60px;
  text-align: center;
  position: relative;
  z-index: 3;
}

.hero-text {
  color: white;
  max-width: 100%;
  margin: 0 auto;
}

.hero-title {
  margin: 0;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  line-height: 1.2;
}

.subtitle {
  display: block;
  font-size: 1.5rem;
  font-weight: 400;
  color: white;
  margin-bottom: 0.5rem;
}

.golden-text {
  color: #EBC226;
  display: block;
  font-size: 50px;
  font-weight: 700;
  text-shadow: 0px 0px 3px rgba(239.53298067000011, 255, 68.17709760734903, 0.55);
}

/* Responsive design */
@media (max-width: 768px) {
  .golden-text {
    font-size: 2.5rem;
  }

  .subtitle {
    font-size: 1.2rem;
  }

  .hero-content {
    padding: 0 40px;
  }

  .account-hero-section {
    height: 50vh;
    min-height: 350px;
  }
}

@media (max-width: 480px) {
  .golden-text {
    font-size: 2rem;
  }

  .subtitle {
    font-size: 1rem;
  }

  .hero-content {
    padding: 0 20px;
  }

  .account-hero-section {
    height: 45vh;
    min-height: 300px;
  }
}
</style>